<template>
  <p :class="klass" v-tooltip="tooltip">
    <i class="fa" v-if="icon" :class="icon"></i><span>{{ customer.shipments_last_week }}</span>
  </p>
</template>
<script>
export default {
  props: ['plans', 'customer', 'compare'],
  data: function () {
    return {
      icon: null,
      percentage: 0,
      klass: '',
      shipments: 0,
      included: 0
    };
  },
  mounted() {},
  methods: {},
  computed: {
    tooltip() {
      return `${this.$i18n.t('shipments')}: ${this.shipments}
          <br>
          ${this.$i18n.t('included')}: ${this.included}
          `;
    }
  }
};
</script>
